import { useRef } from 'react';

/**
 * Returns true iff any value in the deps array changes from one render to the next.
 *
 * If the `deps` array is the exact same array, this will always return false.
 */
export function useDepsChanged(deps: any[]) {
  const depsRef = useRef(deps);

  const answer =
    depsRef.current !== deps &&
    (depsRef.current.length !== deps.length ||
      depsRef.current.some((val, index) => deps[index] !== val));

  if (answer) {
    depsRef.current = deps;
  }

  return answer;
}
